import React from 'utils/react';

import { Block } from 'baseui/block';
import { Button, KIND, SIZE } from 'baseui/button';
import { StatefulPopover, PLACEMENT } from 'baseui/popover';
import { StatefulMenu } from 'baseui/menu';

import { Checkbox, LABEL_PLACEMENT } from 'baseui/checkbox';

import debug from 'utils/debug';
import MenuIcon from './MenuIcon';

import ButtonContainer from './ButtonContainer';
import { withWindowSize } from 'utils/hocs';
import setPopoverHeight from 'utils/popover-height';

const D2 = debug('p:CommuteOffer:Panels:TransitstopTypesMenu');

class TransitstopTypesMenu extends React.PureComponent {
  state = {};
  popoverContent = React.createRef();

  render() {
    D2.S.INFO('render', { props: this.props, MenuIcon });

    const {
      transitstopTypes,
      visibleTransitstopTypes,
      toggleVisibilityTransitstopType,
      windowSize: { height },
    } = this.props;

    const transitstopTypesJs = transitstopTypes ? transitstopTypes.toJS() : [];
    D2.S.INFO('transitstopTypesJs', { transitstopTypesJs });

    const visibleTransitstopTypesSet = new Set(visibleTransitstopTypes.toJS());
    D2.S.INFO('visibleTransitstopTypesSet', { visibleTransitstopTypesSet });

    const setChecked = (transitstopType, value) => {
      D2.S.INFO('setChecked', { transitstopType, value });

      toggleVisibilityTransitstopType(transitstopType);
    };

    return (
      <StatefulPopover
        placement={PLACEMENT.leftTop}
        content={() =>
          !transitstopTypesJs || !transitstopTypesJs.length ? (
            <StatefulMenu
              overrides={{
                Option: {
                  props: {
                    size: 'large',
                  },
                },
              }}
              items={[]}
            />
          ) : (
            <Block
              ref={this.popoverContent}
              padding='10px'
              backgroundColor='menuFill'
              overflow='auto'
            >
              {transitstopTypesJs &&
                transitstopTypesJs.map(item => (
                  <Checkbox
                    key={item}
                    checked={visibleTransitstopTypesSet.has(item)}
                    onChange={e => setChecked(item, e.target.checked)}
                    labelPlacement={LABEL_PLACEMENT.right}
                  >
                    {item}
                  </Checkbox>
                ))}
            </Block>
          )
        }
        onOpen={setPopoverHeight({
          elementRef: this.popoverContent,
          windowHeight: height,
        })}
      >
        <ButtonContainer>
          <Button
            size={SIZE.compact}
            kind={KIND.minimal}
            disabled={!transitstopTypes}
          >
            <MenuIcon />
          </Button>
        </ButtonContainer>
      </StatefulPopover>
    );
  }
}

export default withWindowSize(TransitstopTypesMenu);
